import { type StateCreator } from 'zustand';
import { type User } from '@avanta/shared/types/users';

export interface UserState {
  user: User | null;
  setUser: (user: User) => void;
}

export const createUserSlice =
  <T extends UserState>(): StateCreator<T, [], [], UserState> =>
  set => ({
    user: null,
    setUser: user => set({ user } as Partial<T>),
  });
